import { getSchedule, getEventDay } from '../../api/schedule';
import actions from '../actions/index';

/**
 * Скільки живе кеш місяця. Перемикання «назад-вперед» по місяцях не б'є в API,
 * але кеш свідомо короткий: студент може виконати ДЗ і одразу повернутись у розклад,
 * а колір іконки ДЗ має оновитись.
 */
const MONTH_CACHE_TTL = 60 * 1000;

const readError = (error, fallback) =>
  error?.response?.data?.info?.message || fallback;

/**
 * @param {string} monthKey  'dd.MM.yyyy' — перше число місяця, як того чекає бекенд (show_month).
 */
export function getMonth({ monthKey, token, force = false }) {
  return (dispatch, getState) => {
    const cached = getState().schedule.monthCache[monthKey];

    if (!force && cached && Date.now() - cached.at < MONTH_CACHE_TTL) {
      dispatch(actions.schedule.startFetchingMonth(monthKey));
      dispatch(actions.schedule.getMonthSchedule({ monthKey, events: cached.events }));
      dispatch(actions.schedule.stopFetchingMonth(monthKey));
      return;
    }

    dispatch(actions.schedule.startFetchingMonth(monthKey));

    getSchedule({ type: 'month', url: `?show_month=${monthKey}`, token })
      .then((res) => {
        // 200 з info.status === false теж помилка — інакше користувач побачить
        // порожній місяць і жодного пояснення.
        if (res.data.info.status) {
          dispatch(actions.schedule.getMonthSchedule({ monthKey, events: res.data.data }));
        } else {
          dispatch(actions.schedule.getMonthScheduleError({
            monthKey,
            message: res.data.info.message || 'Не вдалося завантажити розклад на місяць',
          }));
        }
      })
      .catch((error) => {
        dispatch(actions.schedule.getMonthScheduleError({
          monthKey,
          message: readError(error, 'Не вдалося завантажити розклад на місяць'),
        }));
      })
      .finally(() => dispatch(actions.schedule.stopFetchingMonth(monthKey)));
  };
}

/**
 * @param {string} dayKey 'yyyy-MM-dd' — внутрішній ключ дня і одночасно ключ від гонок.
 * @param {string} dateParam 'dd.MM.yyyy' — формат, який чекає ендпоінт /schedule/events.
 */
export function getDay({ dayKey, dateParam, token }) {
  return (dispatch) => {
    dispatch(actions.schedule.startFetchingDay(dayKey));

    getEventDay({ date: dateParam, token })
      .then((res) => {
        if (res.data.info.status) {
          dispatch(actions.schedule.getDayEvent({ dayKey, events: res.data.data }));
        } else {
          dispatch(actions.schedule.getDayEventError({
            dayKey,
            message: res.data.info.message || 'Не вдалося завантажити події дня',
          }));
        }
      })
      .catch((error) => {
        dispatch(actions.schedule.getDayEventError({
          dayKey,
          message: readError(error, 'Не вдалося завантажити події дня'),
        }));
      })
      .finally(() => dispatch(actions.schedule.stopFetchingDay(dayKey)));
  };
}
